import React, { useState } from 'react'
import styled from 'styled-components'
import { useNavigate, useLocation } from 'react-router-dom'
import { Collapse } from 'react-bootstrap'
import { ArrowBigIcon } from '../Icons/ArrowBigIcon'
import useStores from '../../stores/useStore'
import { colors } from '../../styles/colors'
import { observer } from 'mobx-react'
import { withTheme } from 'styled-components'

const StyledContingentList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
`

const NavText = styled.span`
  padding: 3px 10px;
  border-radius: 5px;
  display: inline-flex;
  align-items: center;
`
const StyledContingentTitle = styled.div`
  display: flex;
  align-items: flex-start;
  margin-bottom: 15px;
  cursor: pointer;
  font-size: 18px;
  color: ${colors.textColorB80};
  &:hover ${NavText} {
    color: ${({ theme }) => theme.primaryColor};
  }

  &.active ${NavText} {
    background-color: ${colors.textColorB80};
    color: ${colors.white};
    opacity: 0.7;
  }
  svg {
    margin-top: -2px;
    margin-right: 15px;
  }
`

const StyledProductGroupList = styled.ul`
  list-style: none;
  padding: 0 0 0 15px;
  opacity: 0.6;
`
const StyledProductGroupListItem = styled.li`
  margin: 12px 0;
  cursor: pointer;
  color: ${colors.textColor};

  &:hover ${NavText} {
    color: ${({ theme }) => theme.primaryColor};
  }
  &.active ${NavText} {
    background-color: ${colors.textColorB80};
    color: ${colors.white};
  }
`

const StyledListWrapper = styled.div`
  padding-left: 35px;
  margin-left: 15px;
  margin-bottom: 20px;
`

const AdministrationSidebar = ({ options, active }) => {
  const { uiStore } = useStores()
  const navigate = useNavigate()
  const location = useLocation()

  const [contingentStates, setContingentStates] = useState(() => {
    const initialState = {}
    options.forEach((option) => {
      initialState[option.menuName] = true
    })
    return initialState
  })

  const handleClickTitle = (menuName, goTo) => {
    setContingentStates((prevState) => ({
      ...prevState,
      [menuName]: !prevState[menuName],
    }))
    if (goTo) {
      navigate(goTo)
    }
  }

  const checkRights = (accessRights) => {
    if (Array.isArray(accessRights) && accessRights.length > 0) {
      return accessRights.every((item) => uiStore[item])
    }
    return false
  }

  return (
    <StyledContingentList>
      {options.map((option, index) => {
        const isContingentOpen = contingentStates[option.menuName]
        const hasVisibleSubmenu = option.subMenu.some((subMenu) =>
          checkRights(subMenu.accessRights),
        )
        const hasMenuAccessRights = checkRights(option.accessRights)
        const isSingleMenu = option.subMenu.length === 0

        if (
          hasVisibleSubmenu ||
          hasMenuAccessRights ||
          (isSingleMenu && hasMenuAccessRights)
        ) {
          return (
            <li key={index}>
              <StyledContingentTitle
                className={location.pathname === option.to ? 'active' : ''}
                onClick={() => handleClickTitle(option.menuName, option.to)}
              >
                {hasVisibleSubmenu && !isSingleMenu ? (
                  <NavText>
                    <ArrowBigIcon
                      variant={isContingentOpen ? 'down' : 'right'}
                    />
                    {option.menuName}
                  </NavText>
                ) : (
                  <NavText style={{ marginLeft: '43px' }}>
                    {option.menuName}
                  </NavText>
                )}
              </StyledContingentTitle>
              {hasVisibleSubmenu && (
                <Collapse in={isContingentOpen}>
                  <div>
                    <StyledListWrapper>
                      <StyledProductGroupList>
                        {option.subMenu.map((subMenu, subIndex) => {
                          const hasAccess = checkRights(subMenu.accessRights)
                          if (hasAccess) {
                            return (
                              <StyledProductGroupListItem
                                key={subIndex}
                                className={
                                  location.pathname === subMenu.to
                                    ? 'active'
                                    : ''
                                }
                                onClick={() => navigate(subMenu.to)}
                              >
                                <NavText>{subMenu.name}</NavText>
                              </StyledProductGroupListItem>
                            )
                          }
                          return null
                        })}
                      </StyledProductGroupList>
                    </StyledListWrapper>
                  </div>
                </Collapse>
              )}
            </li>
          )
        }
        return null
      })}
    </StyledContingentList>
  )
}

export default withTheme(observer(AdministrationSidebar))
